import { render } from "./AICourseCreate.vue?vue&type=template&id=40ad6fd7&scoped=true"
import script from "./AICourseCreate.vue?vue&type=script&lang=js"
export * from "./AICourseCreate.vue?vue&type=script&lang=js"

import "./AICourseCreate.vue?vue&type=style&index=0&id=40ad6fd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ad6fd7"]])

export default __exports__